import { boot } from './boot';
require('spectrum-colorpicker2');
boot();
